import React from 'react';
import { connect } from 'react-redux'

import { logOut } from '../auth'

import Anon from '../components/anon'
import Dashboard from './dashboard'


const AppComponent = ({dispatch, authenticate, user}) => {
  let content;
  if (authenticate) {
    content = <Dashboard />
  } else if (authenticate) {
    content = <div>You don't have the right permissions<br /><a href="" onClick={() => logOut(dispatch)}>Sign out</a></div>
  } else {
    content = <Anon />
  }
  return (
    <div className="app">
      {content}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    user: state.user,
    authenticate: state.authenticate,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  }
}

const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppComponent);

export default App



// WEBPACK FOOTER //
// ./src/containers/app.js